import React, { useState } from 'react';

interface NumerologyLabProps {
  lifePathNumber?: number;
  destinyNumber?: number;
  soulUrgeNumber?: number;
  personalityNumber?: number;
  className?: string;
}

const numberDescriptions: Record<number, string> = {
  1: 'Лидер-первопроходец. Вы рождены, чтобы идти впереди, быть независимым и оригинальным. Ваша сила — в инициативе и решимости. Вы обладаете творческой энергией и способностью создавать новое.',
  2: 'Дипломат и посредник. Ваша сила в сотрудничестве, чуткости и умении объединять людей. Вы обладаете даром чувствовать других и создавать гармонию вокруг себя.',
  3: 'Творец и communicator. Вы обладаете даром самовыражения через слово, искусство, юмор. Ваша радость вдохновляет окружающих. Вы призывны нести свет и оптимизм.',
  4: 'Строитель и организатор. Ваша сила в дисциплине, практичности и надёжности. Вы создаёте прочный фундамент для всего, за что берётесь. Порядок и метод — ваш путь к успеху.',
  5: 'Исследователь и авантюрист. Вы рождены для свободы, путешествий и перемен. Ваша любознательность и адаптивность позволяют вам находить возможности там, где другие видят препятствия.',
  6: 'Наставник и хранитель. Ваша миссия — забота о близких, создание красоты и гармонии. Вы обладаете даром исцеления и воспитания. Ответственность и любовь — ваши главные силы.',
  7: 'Мыслитель и искатель истины. Ваш путь — через анализ, медитацию и поиск глубинного смысла. Вы обладаете интуицией и способностью видеть то, что скрыто от других.',
  8: 'Достигатель и управленец. Ваша сила в амбициях, деловой хватке и способности материализовать идеи. Вы рождены для финансового успеха и руководства большими проектами.',
  9: 'Гуманист и филантроп. Ваша миссия — служение человечеству через сострадание и мудрость. Вы обладаете широким взглядом на жизнь и способностью вдохновлять других.',
  11: 'Духовный посланник (Мастер-число). Вы обладаете повышенной интуицией и способностью получать вдохновение из высших источников. Ваша миссия — нести духовное просвещение.',
  22: 'Мастер-строитель (Мастер-число). Вы способны воплощать грандиозные проекты, которые меняют мир. Ваша сила — в сочетании духовного видения с практическим мастерством.',
  33: 'Мастер-учитель (Мастер-число). Высшее проявление нумерологической вибрации. Ваша миссия — безусловная любовь и обучение через личный пример самоотверженности.',
};

const numberKeywords: Record<number, string> = {
  1: 'Лидер · Независимость · Инициатива',
  2: 'Дипломат · Гармония · Чуткость',
  3: 'Творец · Самовыражение · Радость',
  4: 'Строитель · Дисциплина · Надёжность',
  5: 'Исследователь · Свобода · Перемены',
  6: 'Наставник · Забота · Гармония',
  7: 'Мыслитель · Интуиция · Мудрость',
  8: 'Достигатель · Успех · Управление',
  9: 'Гуманист · Сострадание · Служение',
  11: 'Духовный посланник · Интуиция · Просвещение',
  22: 'Мастер-строитель · Грандиозные проекты · Воплощение',
  33: 'Мастер-учитель · Безусловная любовь · Самоотверженность',
};

const NumerologyLab: React.FC<NumerologyLabProps> = ({
  lifePathNumber,
  destinyNumber,
  soulUrgeNumber,
  personalityNumber,
  className = '',
}) => {
  const [expandedNumber, setExpandedNumber] = useState<string | null>(null);

  const renderNumberCard = (
    label: string,
    labelRu: string,
    value: number | undefined,
    color: string,
    borderColor: string,
  ) => {
    if (value === undefined || value === null) return null;

    const isExpanded = expandedNumber === `${label}-${value}`;
    const description = numberDescriptions[value];
    const keywords = numberKeywords[value] || '';

    return (
      <div
        style={{
          background: 'rgba(13, 25, 48, 0.5)',
          border: `1px solid ${borderColor}`,
          borderRadius: '16px',
          padding: '20px',
          marginBottom: '16px',
          cursor: description ? 'pointer' : 'default',
          transition: 'all 0.3s ease',
        }}
        onClick={() => description && setExpandedNumber(isExpanded ? null : `${label}-${value}`)}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '12px' }}>
          <div
            className="number-cell"
            style={{
              width: '56px',
              height: '56px',
              fontSize: '24px',
              fontWeight: 700,
              background: `${color}15`,
              borderColor: color,
              boxShadow: `0 0 15px ${color}40`,
              flexShrink: 0,
            }}
          >
            {value}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '12px', color: '#888', fontFamily: 'var(--font-sans)', marginBottom: '4px' }}>
              {label}
            </div>
            <div style={{ fontSize: '16px', color, fontFamily: 'var(--font-display)', fontStyle: 'italic' }}>
              {labelRu}
            </div>
            {keywords && (
              <div style={{ fontSize: '12px', color: '#aaa', fontFamily: 'var(--font-sans)', marginTop: '4px' }}>
                {keywords}
              </div>
            )}
          </div>
        </div>

        {isExpanded && description && (
          <div
            className="animate-fade-in-up"
            style={{
              marginTop: '12px',
              paddingTop: '12px',
              borderTop: `1px solid ${borderColor}`,
              color: '#e0e0e0',
              fontSize: '14px',
              lineHeight: 1.7,
              fontFamily: 'var(--font-sans)',
            }}
          >
            {description}
          </div>
        )}

        {!isExpanded && description && (
          <div style={{ fontSize: '11px', color: '#666', fontFamily: 'var(--font-sans)', marginTop: '4px' }}>
            Нажмите для расшифровки
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={`glass-panel ${className}`} style={{ padding: '24px' }}>
      <h3
        className="text-cyan"
        style={{
          marginBottom: '24px',
          fontFamily: 'var(--font-display)',
          fontSize: '22px',
          textAlign: 'center',
          textShadow: 'var(--glow-cyan-soft)',
        }}
      >
        Нумерологический профиль
      </h3>

      {renderNumberCard(
        'Life Path Number',
        'Число Жизненного Пути',
        lifePathNumber,
        '#7DD3C0',
        'rgba(125, 211, 192, 0.3)',
      )}

      {renderNumberCard(
        'Destiny Number',
        'Число Destinи (Выражения)',
        destinyNumber,
        '#D4AF37',
        'rgba(212, 175, 55, 0.3)',
      )}

      {renderNumberCard(
        'Soul Urge Number',
        'Число Души (Сердечного Желания)',
        soulUrgeNumber,
        '#C8B8B8',
        'rgba(200, 184, 184, 0.3)',
      )}

      {renderNumberCard(
        'Personality Number',
        'Число Личности (Внешнего проявления)',
        personalityNumber,
        '#9382DC',
        'rgba(147, 130, 220, 0.3)',
      )}
    </div>
  );
};

export default NumerologyLab;
